"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';

var MessageBar = function MessageBar(props) {
  var _classnames;
  var status = props.status,
    role = props.role,
    tagList = props.tagList,
    text = props.text,
    labelList = props.labelList,
    iconButtonList = props.iconButtonList,
    children = props.children,
    className = props.className,
    style = props.style;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('message-bar');
  var classes = (0, _classnames2.default)(prefixCls, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(prefixCls, "--").concat(role), !!role), (0, _defineProperty2.default)(_classnames, "status-".concat(status), !!status), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__inner")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__cont")
  }, !!status && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__status")
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__status-icon")
  })), !!tagList && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__tag")
  }, tagList.map(function (tagItem, tagIndex) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tagItem.text && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__tag-item"),
      key: tagIndex
    }, tagItem.text));
  })), !!text && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__text")
  }, text)), role !== 'self' && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__tool")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__tool-main")
  }, !!labelList && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__label")
  }, labelList.map(function (labelItem, labelIndex) {
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: function onClick(e) {
        (labelItem === null || labelItem === void 0 ? void 0 : labelItem.onClick) && (labelItem === null || labelItem === void 0 ? void 0 : labelItem.onClick(e));
      },
      className: (0, _classnames2.default)("".concat(prefixCls, "__label-item"), {
        'is-active': labelItem === null || labelItem === void 0 ? void 0 : labelItem.active,
        'is-disable': labelItem === null || labelItem === void 0 ? void 0 : labelItem.disable
      }),
      key: labelIndex
    }, (labelItem === null || labelItem === void 0 ? void 0 : labelItem.iconSvg) && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__label-icon")
    }, labelItem === null || labelItem === void 0 ? void 0 : labelItem.iconSvg), (labelItem === null || labelItem === void 0 ? void 0 : labelItem.text) && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__label-text")
    }, labelItem === null || labelItem === void 0 ? void 0 : labelItem.text));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__tool-extra")
  }, !!iconButtonList && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__iconbtn")
  }, iconButtonList.map(function (iconbtnItem, iconbtnIndex) {
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: function onClick(e) {
        (iconbtnItem === null || iconbtnItem === void 0 ? void 0 : iconbtnItem.onClick) && (iconbtnItem === null || iconbtnItem === void 0 ? void 0 : iconbtnItem.onClick(e));
      },
      className: (0, _classnames2.default)("".concat(prefixCls, "__iconbtn-item"), {
        'is-active': iconbtnItem === null || iconbtnItem === void 0 ? void 0 : iconbtnItem.active,
        'is-disable': iconbtnItem === null || iconbtnItem === void 0 ? void 0 : iconbtnItem.disable
      }),
      key: iconbtnIndex
    }, (iconbtnItem === null || iconbtnItem === void 0 ? void 0 : iconbtnItem.iconSvg) && /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__iconbtn-icon")
    }, iconbtnItem === null || iconbtnItem === void 0 ? void 0 : iconbtnItem.iconSvg));
  })))), !!children && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__addon")
  }, children)));
};
MessageBar.defaultProps = {};
var _default = exports.default = MessageBar;